import React from "react";
import { cn } from "../lib/api";
import ClubSwitcher from "./ClubSwitcher";

export default function TopBar({ title, subtitle, right, children, showClubSwitcher = true, className }) {
  return (
    <div className={cn("px-5 pt-6 pb-3", className)}>
      {/* Row 1: Greeting + Club Name */}
      <div>
        {subtitle && (
          <div className="text-xs uppercase tracking-widest text-ink-muted font-semibold">
            {subtitle}
          </div>
        )}
        <h1 className="text-2xl font-bold text-ink leading-tight">{title}</h1>
      </div>

      {/* Row 2: Switcher + Join Code */}
      <div className="flex items-center justify-between gap-3 mt-2">
        {showClubSwitcher && <ClubSwitcher />}
        <div className="flex items-center gap-2 ml-auto shrink-0">
          {children}
          {right}
        </div>
      </div>
    </div>
  );
}